(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7289],{

/***/ 7155:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[page]",
      function () {
        return __webpack_require__(9609);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8363);
/* harmony import */ var _styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3193);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);







var Page = function(param) {
    var page = param.page;
    var body = page.body;
    body = page.body.replace(/<a/g, '<a target="_blank"').replace(/<img/g, '<img class="imgW100"');
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "".concat(page.seo.title),
                description: "".concat(page.seo.description),
                openGraph: {
                    url: "https://".concat("baza.estate", "/").concat(page.slugCategory, "/").concat(page.slug),
                    type: "website",
                    title: "".concat(page.seo.title),
                    description: "".concat(page.seo.description),
                    images: [
                        {
                            url: page.image ? page.title : "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "fixed",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "16",
                                    height: "16",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 38.273 38.273",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    className: (_styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6___default().breadcrumbsSplitter),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M20.621 10.484V5.84c0-.808-.458-1.548-1.181-1.909a2.142 2.142 0 0 0-2.236.206l-9.486 7.147c-.677.292-1.117.67-1.401 1.058L.849 16.461a2.134 2.134 0 0 0 .013 3.418l16.355 12.133a2.132 2.132 0 0 0 3.404-1.714v-5.517h.038c3.842 0 10.687 1.089 13.366 8.386a2.134 2.134 0 0 0 4.117-.456c.052-.394 1.208-9.682-4.461-16.23-3.06-3.533-7.446-5.546-13.06-5.997zm.038 10.031c-1.443 0-2.379.132-2.482.146a2.134 2.134 0 0 0-1.822 2.111v3.287l-10.66-7.907 3.555-2.678a2.21 2.21 0 0 0 .365-.351c.155-.068.301-.152.437-.254l6.303-4.75v2.401c0 1.168.939 2.119 2.108 2.134 5.345.063 9.374 1.61 11.975 4.6 1.442 1.658 2.314 3.602 2.835 5.469-4.35-3.685-9.849-4.208-12.614-4.208z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/news",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        className: (_styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6___default().breadcrumbsItem),
                                        style: {
                                            marginLeft: 12
                                        },
                                        children: "вернуться в новости"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "fixed",
                                (_styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6___default().timeline)
                            ].join(" "),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: page.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "fixed",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_faq_Page_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
                                dangerouslySetInnerHTML: {
                                    __html: body
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                seo: page.seo.title
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 8363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Page_breadcrumbs__Hxho4","breadcrumbsItem":"Page_breadcrumbsItem__5fdyJ","breadcrumbsSplitter":"Page_breadcrumbsSplitter__aw64T","timeline":"Page_timeline__xaYkR","timelineImage":"Page_timelineImage__v6STT","description":"Page_description__CyMYb","dates":"Page_dates__kzwYP","datesItem":"Page_datesItem__EaNCf","datesItemTitle":"Page_datesItemTitle__eT4D7"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,798,3193,9774,2888,179], function() { return __webpack_exec__(7155); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);